import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import weekday from 'dayjs/plugin/weekday';
import duration from 'dayjs/plugin/duration';

dayjs.extend(isoWeek);
dayjs.extend(weekday);
dayjs.extend(duration);

export default dayjs;